import { Button, Select, Table, notification } from 'antd'
import React, { useEffect, useState } from 'react'
import { getAllTeamsList } from '../../redux/actions/teamActions'
import { useSelector } from 'react-redux'
import {
  createDraftRound,
  createRandomizedDraftRound,
  deleteDraftRound,
  generateAllRound,
  getDraftRound,
} from '../../redux/actions/draftAction'

const DraftOrder = () => {
  const positionLength = 5
  const roundLength = 23
  const { loading, draftRounds } = useSelector((state) => state.draft)
  const [data, setData] = useState([])
  const [teams, setTeams] = useState([])
  const [ids, setIds] = useState(
    Object.fromEntries(Array.from({ length: roundLength }, (_, i) => [i + 1, []])),
  )
  const [btnLoading, setBtnLoading] = useState(false)

  const getMock = () => {
    const _data = []

    for (let i = 1; i <= positionLength; i++) {
      const obj = {
        position: i,
        rounds: [],
      }
      for (let n = 1; n <= roundLength; n++) {
        obj.rounds.push({
          round: n,
          //   disabled: n !== 1 ? true : false,
          disabled: false,
          team: '',
          _id: '',
        })
      }
      _data.push(obj)
    }
    return _data
  }

  useEffect(() => {
    // _getDraftRound()
    _getTeams()
  }, [])

  useEffect(() => {
    getData()

    return () => {
      setIds(Object.fromEntries(Array.from({ length: roundLength }, (_, i) => [i + 1, []])))
    }
  }, [draftRounds])

  const getData = () => {
    const mockData = [...getMock()]
    draftRounds?.forEach((v) => {
      const positionIndex = mockData?.findIndex((x) => v?.position === x?.position)
      const roundIndex = mockData[positionIndex].rounds?.findIndex((x) => v?.round === x?.round)
      mockData[positionIndex].rounds[roundIndex].team = v?.team?._id
      mockData[positionIndex].rounds[roundIndex]._id = v?._id

      // SET TEAM IDS
      //   setIds((prevIds) => {
      //     const updatedRound = [...prevIds[roundIndex + 1], v?.team]
      //     return {
      //       ...prevIds,
      //       [roundIndex + 1]: updatedRound,
      //     }
      //   })
      setIds((prevIds) => {
        const updatedRound = [...prevIds[roundIndex + 1]]
        if (!updatedRound.includes(v?.team?._id)) {
          updatedRound.push(v?.team?._id)
        }
        return {
          ...prevIds,
          [roundIndex + 1]: updatedRound,
        }
      })
    })
    setData(mockData)
  }

  const _getTeams = async () => {
    const res = await getAllTeamsList()
    setTeams(res)
    await getDraftRound()
  }

  //   const _getDraftRound = async () => {
  //     // await getDraftRound()
  //   }

  const handleSelect = async (value, position, round) => {
    const temp = [...data]
    temp[position - 1].rounds[round - 1].team = value
    setData(temp)

    // SET TEAM IDS
    setIds((prevIds) => ({
      ...prevIds,
      [round]: [...prevIds[round], value],
    }))

    await createDraftRound({
      team: value,
      position,
      round,
    })
  }

  const handleClear = async (value, position, round, teamId) => {
    const temp = [...data]
    temp[position - 1].rounds[round - 1].team = ''
    setData(temp)

    // SET TEAM IDS
    setIds((prevIds) => ({
      ...prevIds,
      [round]: prevIds[round].filter((id) => id !== teamId),
    }))

    await deleteDraftRound(value)
  }

  const handleRandomized = async () => {
    // await createRandomizedDraftRound()
    // const _data = [
    //   {
    //     position: 1,
    //     rounds: [],
    //   },
    // ]
    // const existingNumbers = new Set()
    // while (existingNumbers.size < roundLength) {
    //   const randomNumber = Math.floor(Math.random() * roundLength) + 1
    //   if (!existingNumbers.has(randomNumber)) {
    //     existingNumbers.add(randomNumber)
    //     _data[0].rounds.push({
    //       //   key: randomNumber,
    //       //   position: 1,
    //       round: randomNumber,
    //       disabled: randomNumber !== 1 ? true : false,
    //       team: teams[randomNumber] ? teams[randomNumber]._id : '',
    //       _id: '',
    //     })
    //   }
    // }
    // console.log(_data.sort((a, b) => a.key - b.key))
  }

  const handleGenerateAllRound = async () => {
    setBtnLoading(true)
    await getDraftRound(false)
    const isComplete = draftRounds?.filter((v) => v?.round === 1)
    if (isComplete?.length === positionLength) {
      await generateAllRound()
    } else {
      notification.error({
        message: 'First complete round 1',
        duration: 3,
      })
    }
    setBtnLoading(false)
  }

  const columns = [
    {
      title: ' ',
      dataIndex: `key`,
      key: `key`,
      render: (_, obj, i) => <p>{i + 1}</p>,
    },
    ...Array(roundLength)
      .fill({})
      .map((v, i) => {
        const index = i + 1
        return {
          title: `Round${index}`,
          dataIndex: `round${index}`,
          key: `round${index}`,
          render: (_, record) => {
            const obj = record.rounds.find((v) => v?.round === index)

            return (
              <Select
                size={'middle'}
                placeholder=' '
                style={{
                  width: '100%',
                }}
                disabled={obj?.disabled}
                value={obj?.team}
                onChange={(value) => {
                  if (value !== undefined) {
                    handleSelect(value, record?.position, obj?.round)
                  }
                }}
                allowClear
                onClear={() => handleClear(obj?._id, record?.position, obj?.round, obj?.team)}
                options={teams?.map((v) => {
                  return {
                    value: v?._id,
                    label: v?.name,
                    disabled: ids[obj?.round]?.includes(v?._id),
                  }
                })}
              />
            )
          },
          width: 150,
        }
      }),
  ]

  return (
    <div className='team_ownership_container'>
      <div style={{ display: 'flex', gap: '10px', marginBlock: '20px' }}>
        <Button type='primary' onClick={handleRandomized}>
          RANDOMIZED DRAFT ORDER
        </Button>
        <Button loading={btnLoading} type='primary' onClick={handleGenerateAllRound}>
          GENERATE FOR ALL ROUNDS
        </Button>
      </div>
      <div className='t_o_form_box'>
        <Table
          loading={loading}
          columns={columns}
          dataSource={data}
          pagination={false}
          scroll={{ x: 3000 }}
        />
      </div>
    </div>
  )
}

export default DraftOrder
